/**
 *
 * @module personalizationEvent
 *
 */

import UserActivityEvent from './../userActivityEvent';

/**
 *
 * @class PersonalizationEvent
 *
 */
export default class PersonalizationEvent extends UserActivityEvent {

    /**
     *
     * @param {String} eventUrn
     *
     */
    constructor(eventUrn) {

        super(eventUrn);

    }

}



// WEBPACK FOOTER //
// ./src/userActivity/personalization/personalizationEvent.js